import styled from 'styled-components/macro'

export const MyWorkContainer = styled.div`
  background: #f8f8f8;
`

export const ProjectRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9f9fb;
  padding: 2rem 0;
  background-size: cover;
  @media screen and (max-width: 768px) {
    padding: 1.5rem 0;
    flex-direction: column;
  }
`
export const ProjectColumn = styled.div`
  margin-bottom: 1rem;
  max-width: 50%;
  flex-basis: 50%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  @media screen and (max-width: 768px) {
    max-width: 100%;
    flex-basis: 100%;
  }
`

export const Img = styled.img`
  padding-right: 0;
  border: 0;
  max-width: 100%;
  vertical-align: middle;
  display: inline-block;
  max-height: 20rem;
`

export const ProjectName = styled.h1`
  font-family: 'Lexend Exa', sans-serif;
  font-size: 2.25rem;
  font-weight: 580;
  color: #232151;
  @media screen and (max-width: 768px) {
    font-size: 1.5rem;
    font-weight: 400;
    font-size: 1.75rem;
  }
`
export const ProjectDesc = styled.p`
  font-family: 'Inter', sans-serif;
  max-width: 440px;
  margin: 1rem 0;
  font-size: 1rem;
  line-height: 24px;
  color: #686a9e;

  margin-top: 0.8rem;
  @media screen and (max-width: 768px) {
    font-size: 0.85rem;
    margin-bottom: 0;
  }
`

export const TagsDiv = styled.div`
  font-family: 'Ubuntu', sans-serif;

  margin: 0.5rem 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  @media screen and (max-width: 768px) {
    font-size: 0.75rem;
  }
`
export const Tag = styled.h3`
  border-radius: 5px;
  background: rgba(227, 60, 60, 0.66);
  padding: 0.5rem 1rem;
  margin: 1rem 2rem 1rem 0;
  color: #141414;
`

export const ProjectsAndBlogsContainer = styled.div`
  margin: 1rem 8rem;
  @media screen and (max-width: 768px) {
    margin: 1rem 3rem;
  }
`

// blogs
export const BlogList = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
  }
`
export const BlogDiv = styled.div`
  flex: 0 0 25%;
  font-family: 'Inter', sans-serif;
  @media screen and (max-width: 768px) {
    margin-bottom: 2.5rem;
  }
`
export const BlogImage = styled.div`
  margin-bottom: 1rem;
  border-radius: 0.3rem;
  overflow: hidden;

  background-size: cover;

  background-position: center center;
  img {
    object-fit: contain;
    max-width: 100%;
    max-height: 100%;
  }
`
export const BlogTitle = styled.div`
  font-size: 1.25rem;
  font-weight: 400;
  margin-bottom: 1rem;
`
export const BlogTags = styled.div`
  font-size: 1rem;
  color: #111;
  margin-bottom: 2rem;
  overflow: hidden;
`
